import { Helmet } from "react-helmet-async";
import AboutPageIcon from "../components/Icons/AboutPageIcon";
import usePageReset from "../hooks/usePageReset";
import structuredData from "../assets/structuredText";

export default function About() {
  usePageReset();

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0" />
        <meta name="keywords" content="cultiv" />
        <meta
          name="description"
          content="Learn about Cultiv LLC, our mission to support innovation, build a global
network of experts, and how we empower businesses and entrepreneurs to
thrive."
        />
        <meta name="robots" content="index, follow" />
        <meta property="og:url" content="https://cultiv.llc" />
        <meta property="og:type" content="website" />
        <meta
          property="og:image"
          itemProp="image"
          content="https://cultiv.llc/images/metaimg.jpg"
        />
        <link rel="image_src" itemProp="image" href="https://cultiv.llc/images/metaimg.jpg" />
        <meta
          property="og:description"
          content="Learn about Cultiv LLC, our mission to support innovation, build a global
network of experts, and how we empower businesses and entrepreneurs to
thrive."
        />
        <meta property="og:site_name" content="Cultiv LLC" />
        <meta property="og:title" content="Cultiv | About" />
        <meta property="twitter:card" content="summary_large_image" />
        <meta property="twitter:url" content="https://cultiv.llc" />
        <meta property="twitter:title" content="Cultiv | About" />
        <meta
          property="twitter:description"
          content="Learn about Cultiv LLC, our mission to support innovation, build a global
network of experts, and how we empower businesses and entrepreneurs to
thrive."
        />
        <meta property="twitter:image" content="https://cultiv.llc/images/metaimg.jpg" />
        <link rel="canonical" href="https://cultiv.llc" />
        <script type="application/ld+json">{structuredData}</script>
        <title>About Cultiv</title>
      </Helmet>
      <div className="w-full bg-black">
        <AboutPageIcon />
      </div>
      <div className="flex flex-col px-8  md:px-15 lg:px-20 xl:px-30">
        <div className="flex flex-col justify-center items-center gap-4 ">
          <div className="flex flex-col gap-4 justify-start items-start py-2 leading-9">
            <h1 className="text-gray-900 md:text-2xl text-xl font-expandedBold  text-center mt-5">
              About Us
            </h1>
            <p className="text-gray-800 lg:text-xl lg:leading-9 text-left md:text-lg text-sm md:leading-9	">
              Cultiv is a platform for supporting innovation through venture building, networking
              and community building. Our mission is to empower entrepreneurs, innovators,
              technologists and designers in Europe and the MENA region. We do this through the
              continuous development of a global network of experts, professionals and investors.
              Our members operate in a number of activity areas, including venture building,
              technology product development, incubation/acceleration of startups, international
              technology and innovation competitions, venture capital, turnkey business solutions
              for SMEs, global market access, and operating co-working and innovation spaces. We are
              connected with an extensive network of clusters, tech hubs, universities, government
              agencies and other organizations in the areas of deep-tech and ICT, in Europe and the
              MENA region, with a special focus in the areas of AI, software, design, fintech,
              semiconductors, electronics, hardware, biotech, cybersecurity, digital transformation,
              agri-tech, cleantech, climate and travel.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
